import Sidebar from './pages/Sidebar';
import { Outlet } from 'react-router-dom';
import Hamburger from './pages/Hamburger';
import { useEffect, useState } from 'react';

export default function MainLayout() {
  const [collapsed, setCollapsed] = useState(window.innerWidth < 1920);
  useEffect(() => {
    let lastWidth = window.innerWidth;
    const onResize = (e: UIEvent) => {
      const width = window.innerWidth;
      if (width < 1920) {
        setCollapsed(true);
      } else if (width >= 1920 && lastWidth < 1920) {
        setCollapsed(false);
      }
      lastWidth = width;
    }
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    }
  }, []);
  return (
    <div className="flex relative w-full h-full items-start">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} className="max-md:hidden" />
      <Hamburger className="md:hidden" />
      <div className="overflow-auto md:p-6 max-h-full min-h-screen grid w-full [scrollbar-gutter:stable] calendar-content">
        <Outlet />
      </div>
    </div>
  );
}
